import { get } from 'stash/utils';
import { createSelector } from 'reselect';

export const userSelector = (state) => get(state, 'entities.user', {});

export const userLegalNameSelector = createSelector(userSelector, (user) => {
	const first_name = get(user, 'first_name', '');
	const last_name = get(user, 'last_name', '');
	return {
		first_name,
		last_name,
	};
});

export const selectPlatformTier = (state) => {
	return get(state, 'entities.user.platform_tier', {});
};

export const selectPlatformTierFeeWaiver = (state) => {
	return get(state, 'entities.user.fee_waiver.waivedTiers', []);
};

export const selectHasUserPlatformTierFeeWaived = (state) => {
	const userActivePlatformTier = get(state, 'entities.user.platform_tier.type');
	const waivedTiers = get(state, 'entities.user.fee_waiver.waivedTiers', []);
	return waivedTiers.includes(userActivePlatformTier);
};
